import { useDarkMode } from 'context/DarkModeContext';
import useCheckPC from 'hooks/useCheckPC';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

const Sort = ({ closeNav, closeHeaderNav, showLoading }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { darkMode } = useDarkMode();
  const listRef = useRef(null);
  const { isMobile, isTabletSmall } = useCheckPC();

  const selectedColor = darkMode ? 'var(--color-white)' : 'var(--color-black)';
  const unselectedColor = darkMode ? 'var(--color-grey)' : '';

  const handleInputChange = sort => {
    const newSearchParams = sort === 'Default' ? { filter: 'All' } : { sort: sort };
    setSearchParams(newSearchParams);
    showLoading();
    !isMobile && !isTabletSmall ? closeNav() : closeHeaderNav();
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (listRef.current) {
      const listItems = listRef.current.children;

      Array.from(listItems).forEach((item, index) => {
        setTimeout(() => {
          item.classList.add('show');
        }, index * 50);
      });
    }
  }, []);

  return (
    <ul className={'menu-items'} ref={listRef}>
      {sorts.map((sort, index) => {
        const sortParam = searchParams.get('sort');
        const isSortSelected = sortParam === sort || (sortParam === null && sort === 'Default');
        return (
          <li key={sort}>
            <input id={sort} type={'radio'} onChange={() => handleInputChange(sort)} checked={isSortSelected} />
            <label htmlFor={sort}>
              <span
                className={'checkbox'}
                style={{ backgroundColor: isSortSelected ? selectedColor : unselectedColor }}
              ></span>
              {sort && <span style={{ color: isSortSelected ? selectedColor : unselectedColor }}>{sort}</span>}
            </label>
          </li>
        );
      })}
    </ul>
  );
};

export default Sort;

const sorts = ['Default', 'Categories', 'Color', 'Material'];
